import { render, staticRenderFns } from "./SelectItemIntents.vue?vue&type=template&id=b32390ee&scoped=true&"
import script from "./SelectItemIntents.vue?vue&type=script&lang=js&"
export * from "./SelectItemIntents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32390ee",
  null
  
)

export default component.exports